export default "__VITE_ASSET__CKR6NhE6__"